import { InvoiceModel } from '../models/invoice.model';
import { ApiService } from './api.service';
import { Injectable } from '@angular/core';
import { Estate, EarticleType } from '../utils/enum.util';
import { ArticleModel } from '../models/article.model';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

@Injectable()
export class InvoiceService {

    private antiRebound = 300;
    private timestamp   = 0;

    constructor(public apiService: ApiService, private location: Location, private router: Router) {

    }

    loadCustomer(privateId: string, invoice: InvoiceModel) {
        this.apiService.get('client', 'privateId=' + privateId).subscribe(res=> {
            invoice.infoClientName   = res.data.lastName + ' ' + res.data.firstName;
            invoice.infoClientAdress = res.data.adress.name + '\n' + res.data.adress.code + ' ' + res.data.adress.city + '\n' + res.data.adress.country;
        }, (_err)=> {
            this.apiService.error(_err);
        });
    }

    generateData(invoice: InvoiceModel) {
        let articles: any = [];
        let article: any  = {};

        invoice.articles.forEach((a)=> {
            article = {
                'type'    : a.getTypeText(),
                'price'   : a.price.toString(),
                'free'    : a.free.toString(),
                'quantity': a.quantity.toString(),
                'about'   : a.about
            };

            if (a.getTypeText() == 'bike') {
                article.about        = null;
                article.bike         = {};
                article.bike.id      = a.bike.id;
                article.bike.brand   = a.bike.brand;
                article.bike.model   = a.bike.model;
                article.bike.size    = a.bike.size;
                article.bike.numCad  = a.bike.numCad;
                article.bike.comment = a.bike.comment;
            }

            articles.push(article);
        });

        let data: any = {
            billPublicId      : invoice.publicId,
            where             : invoice.where,
            when              : invoice.whenYear.toString() + '-' +
            ('0' + (((invoice.whenMonth)).toString())).slice(-2) + '-' +
            ('0' + (invoice.whenDay.toString())).slice(-2),
            comment           : invoice.info,
            infoClientName    : invoice.infoClientName,
            infoClientAdress  : invoice.infoClientAdress,
            nbHourWorkForce   : '0',
            priceHourWorkForce: invoice.priceHourWorkForce.toString(),
            shippingPrice     : '0',
            discount          : '0',
            advance           : '0',
            magasin           : invoice.magasin,
            articles          : articles,
            useless           : invoice.useless.toString()
        };

        /*if (invoice.paid && invoice.paid.date && invoice.paid.date.year) {
         console.log(invoice.paid);
         data.paid = invoice.paid.date.year + '-' + ('0' + (((invoice.paid.date.month)).toString())).slice(-2) + '-' + ('0' + (((invoice.paid.date.day)).toString())).slice(-2);
         data.paid = invoice.paid.jsdate;
         }
         else
         data.paid = null;
         */

        data.paid = invoice.paid;
        if (invoice.advance)
            data.advance = invoice.advance.toString();

        if (invoice.nbHourWorkForce)
            data.nbHourWorkForce = invoice.nbHourWorkForce.toString();

        if (invoice.shippingPrice)
            data.shippingPrice = invoice.shippingPrice.toString();

        if (invoice.discount)
            data.discount = invoice.discount.toString();

        if (invoice.privateId) {
            data.privateId = invoice.privateId;
        } else {
            data.clientPrivateId = invoice.clientPrivateId;
        }

        return data;
    }

    load(invoicePrivateId: string, invoice: InvoiceModel) {
        this.apiService.get('bill', 'privateId=' + invoicePrivateId).subscribe(res=> {
            invoice.privateId          = res.data._id;
            invoice.advance            = res.data.advance;
            invoice.archive            = res.data.archive;
            invoice.publicId           = res.data.billPublicId;
            invoice.clientPrivateId    = res.data.clientPrivateId;
            invoice.info               = res.data.comment;
            invoice.discount           = res.data.discount;
            invoice.infoClientAdress   = res.data.infoClientAdress;
            invoice.infoClientName     = res.data.infoClientName;
            invoice.nbHourWorkForce    = res.data.nbHourWorkForce;
            invoice.priceHourWorkForce = res.data.priceHourWorkForce;
            invoice.shippingPrice      = res.data.shippingPrice;
            invoice.useless            = res.data.useless;
            invoice.where              = res.data.where;
            invoice.paid               = res.data.paid;
            invoice.magasin            = res.data.magasin;
            invoice.setWhen(res.data.when);
            res.data.articles.forEach((a)=> {
                let article      = new ArticleModel(invoice);
                article.about    = a.about;
                article.free     = a.free;
                article.price    = a.price;
                article.quantity = a.quantity;
                if (a.type == 'service')
                    article.type = EarticleType.Service;
                if (a.type == 'accessory')
                    article.type = EarticleType.Accessory;
                if (a.type == 'bike') {
                    article.type = EarticleType.Bike;
                    article.bike = a.bike;
                }
                invoice.articles.push(article);
            });

            invoice.paid = res.data.paid;

            /*if (res.data.paid == null) {
                invoice.paid = null;
            } else {
                let date = new Date(res.data.paid);

                invoice.paid = {
                    date: {
                        year : date.getFullYear(),
                        month: date.getMonth(),
                        day  : date.getDate()
                    }
                };
            }*/

            if (invoice.advance == 0)
                invoice.advance = null;

            if (invoice.nbHourWorkForce == 0)
                invoice.nbHourWorkForce = null;

            if (invoice.shippingPrice == 0)
                invoice.shippingPrice = null;

            if (invoice.discount == 0)
                invoice.discount = null;

            invoice.calculateValue();
            invoice.validateArticles();
            invoice.validate();
            invoice.state = Estate.Save;
        }, (_err)=> {
            this.apiService.error(_err);
        });
    }

    duplicate(invoicePrivateId: string, invoice: InvoiceModel, redirect: boolean = false) {
        this.apiService.get('bill', 'privateId=' + invoicePrivateId).subscribe(res=> {
            invoice.privateId          = null;
            invoice.advance            = res.data.advance;
            invoice.archive            = res.data.archive;
            invoice.publicId           = res.data.billPublicId;
            invoice.clientPrivateId    = res.data.clientPrivateId;
            invoice.info               = res.data.comment;
            invoice.discount           = res.data.discount;
            invoice.infoClientAdress   = res.data.infoClientAdress;
            invoice.infoClientName     = res.data.infoClientName;
            invoice.nbHourWorkForce    = res.data.nbHourWorkForce;
            invoice.priceHourWorkForce = res.data.priceHourWorkForce;
            invoice.shippingPrice      = res.data.shippingPrice;
            invoice.useless            = true;
            invoice.where              = res.data.where;
            invoice.paid               = res.data.paid;
            invoice.magasin            = res.data.magasin;
            invoice.setWhen(res.data.when);
            if (invoice.articles.length > 0)
                invoice.articles = [];
            res.data.articles.forEach((a)=> {
                let article      = new ArticleModel(invoice);
                article.about    = a.about;
                article.free     = a.free;
                article.price    = a.price;
                article.quantity = a.quantity;
                if (a.type == 'service')
                    article.type = EarticleType.Service;
                if (a.type == 'accessory')
                    article.type = EarticleType.Accessory;
                if (a.type == 'bike') {
                    article.type = EarticleType.Bike;
                    article.bike = a.bike;
                }
                invoice.articles.push(article);
            });
            invoice.calculateValue();
            invoice.validateArticles();
            invoice.validate();
            invoice.state = Estate.Save;
            this.create(invoice, redirect);
        }, (_err)=> {
            this.apiService.error(_err);
        });
    }

    delete(invoice: InvoiceModel, action: string) {
        let data;

        //patch pour désarchiver
        if (action == 'delete')
            data = {privateId: invoice.privateId, confirm: 'true'};
        if (action == 'archive')
            data = {privateId: invoice.privateId, confirm: 'false'};
        if (action == 'unarchive')
            data = {privateId: invoice.privateId, unarchive: 'true'};

        this.apiService.delete('bill', data).subscribe((_res)=> {
            if (action == 'delete') {
                this.router.navigateByUrl('/customer/' + invoice.clientPrivateId);
            } else {
                invoice.archive = !invoice.archive;
            }
        }, (_err)=> {
            this.apiService.error(_err);
        });
    }

    update(invoice: InvoiceModel) {
        //antiRebounce
        this.timestamp = new Date().getTime();
        setTimeout(()=> {
            if (this.timestamp + this.antiRebound <= new Date().getTime()) {
                this.apiService.put('bill', this.generateData(invoice)).subscribe((_res)=> {
                    invoice.state = Estate.Save;
                }, (_err)=> {
                    this.apiService.error(_err);
                    invoice.state = Estate.Error;
                });
            }
        }, this.antiRebound);
    }

    create(invoice: InvoiceModel, redirect: boolean = false) {
        //antiRebounce
        this.timestamp = new Date().getTime();
        setTimeout(()=> {
            if (this.timestamp + this.antiRebound <= new Date().getTime()) {
                this.apiService.post('bill', this.generateData(invoice)).subscribe(res=> {
                    invoice.state     = Estate.Save;
                    invoice.privateId = res.data.privateId;
                    this.location.replaceState('/invoice/' + invoice.clientPrivateId + '/' + invoice.privateId);
                    if (redirect) {
                        this.router.navigate(['invoice', invoice.clientPrivateId, invoice.privateId]);
                    }
                }, (_err)=> {
                    this.apiService.error(_err);
                    invoice.state = Estate.Error;
                });
            }
        }, this.antiRebound);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/services/invoice.service.ts